import PropTypes from 'prop-types'

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import 'dayjs/locale/en'

import dayjs from 'dayjs'

import './index.css'

const PickerDateComponent = ({ value, config={}, events={} }) => {
    const handleChange = (val) => {
        if (events.handleChange)
            events.handleChange(val.format('YYYY-MM-DD HH:mm:ss'))
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
            <DateTimePicker
                className="c-PickerDate"
                label={config.label}
                value={dayjs(value)}
                onChange={handleChange}
                format="MMM D, YYYY h:mm A"
                slotProps={{
                    textField: {
                        fullWidth: true,
                        size: config.size || 'small',
                        helperText: config.helperText
                    }
                }} />
        </LocalizationProvider>
    )
}

PickerDateComponent.propTypes = {
    value: PropTypes.string,

    config: PropTypes.shape({
        label: PropTypes.string,
        helperText: PropTypes.string,
        size: PropTypes.oneOf(['small', 'medium'])
    }),

    events: PropTypes.shape({
        handleChange: PropTypes.func
    })
}

export { PickerDateComponent }